import { ReactElement, ReactNode } from 'react'
import { Box, useTheme } from '@mui/material'

export type SortButtonGroupProps = {
  children: ReactNode
  /** 28 in list toolbars; 40 beside a small text field. */
  height?: number
}

/** Bordered frame around one or more `SortButton`s, which it separates with dividers. */
const SortButtonGroup = ({ children, height = 28 }: SortButtonGroupProps): ReactElement => {
  const theme = useTheme()
  return (
    <Box
      sx={{
        display: 'inline-flex',
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 1,
        overflow: 'hidden',
        height,
        flexShrink: 0,
      }}
    >
      {children}
    </Box>
  )
}

export default SortButtonGroup
